export default __webpack_public_path__ + "static/media/PenIcon.8ed3017e.svg";